import {
  ApproverDelegatee,
  type ApproverDelegateeConstructor,
} from '../ApproverDelegatee'
import {
  PrimaryCategory,
  type PrimaryCategoryConstructor,
} from '../PrimaryCategory'
import {
  SecondaryCategory,
  type SecondaryCategoryConstructor,
} from '../SecondaryCategory'
import { User, type UserConstructorData } from '../User'

export interface ApproverConstructor extends UserConstructorData {
  approvalDelegatee: Nullable<ApproverDelegateeConstructor>
  primaryCategory: Nullable<PrimaryCategoryConstructor>
  secondaryCategory: Nullable<SecondaryCategoryConstructor>
  level?: number // Only defined when approver comes from new approval workflow
  triggersFinalApproval?: Nullable<boolean> // Only defined when approver comes from new approval workflow. It indicates if this submitting this request triggers final approval in a self-approval scenario.
  groupName?: Nullable<string>
}

export class Approver extends User {
  approvalDelegatee: Nullable<ApproverDelegatee>
  level: Nullable<number>
  primaryCategory: Nullable<PrimaryCategory>
  secondaryCategory: Nullable<SecondaryCategory>
  triggersFinalApproval?: Nullable<boolean>
  groupName: Nullable<string>

  constructor(data: ApproverConstructor) {
    super(data)

    this.approvalDelegatee = data.approvalDelegatee
      ? new ApproverDelegatee(data.approvalDelegatee)
      : null

    this.primaryCategory = data.primaryCategory
      ? new PrimaryCategory({
          id: data.primaryCategory.id,
          name: data.primaryCategory.name,
        })
      : null

    this.secondaryCategory = data.secondaryCategory
      ? new SecondaryCategory({
          id: data.secondaryCategory.id,
          name: data.secondaryCategory.name,
          primaryCategory: data.secondaryCategory.primaryCategory,
        })
      : null

    this.level = data.level ?? null
    this.triggersFinalApproval = data.triggersFinalApproval ?? null
    this.groupName = data.groupName ?? null
  }

  get hasApprovalDelegatee() {
    return !!this.approvalDelegatee
  }
}
